import { api } from '../../../system/api'

export default {

    createPackageConsignment: (payload) => api.post('/packages/create-shipment-order-by-customer', payload),
    getTask: (taskId) => api.get(`/tasks/${taskId}`),
};
